const MODULE_NAME = 'PATIENT_FORM';
const CLEAR = MODULE_NAME + 'CLEAR';
const FETCH_PATIENT_STARTED = MODULE_NAME + 'FETCH_PATIENT_STARTED';
const FETCH_PATIENT_COMPLETED = MODULE_NAME + 'FETCH_PATIENT_COMPLETED';
const FETCH_PATIENT_COMPLETED_WITHOUT_RELOAD = MODULE_NAME + 'FETCH_PATIENT_COMPLETED_WITHOUT_RELOAD';
const FETCH_COUNTS_COMPLETED = MODULE_NAME + 'FETCH_COUNTS_COMPLETED';
const UPDATE_INSTRUCTION_SEND_AT = MODULE_NAME + 'INSTRUCTION_SEND_AT';
const ADD_PATIENT_DEVICE = MODULE_NAME + 'ADD_PATIENT_DEVICE';
const DELETE_PATIENT_DEVICE = MODULE_NAME + 'DELETE_PATIENT_DEVICE';
const LOCK_TOGGLE = MODULE_NAME + 'LOCK_TOGGLE';

export {
  CLEAR,
  FETCH_PATIENT_COMPLETED,
  FETCH_PATIENT_STARTED,
  FETCH_COUNTS_COMPLETED,
  UPDATE_INSTRUCTION_SEND_AT,
  ADD_PATIENT_DEVICE,
  DELETE_PATIENT_DEVICE,
  FETCH_PATIENT_COMPLETED_WITHOUT_RELOAD,
  LOCK_TOGGLE
};
